import { ITimeTrackerLocalStorage, TIME_TRACKER_LOCALSTORAGE } from '../types';

export const setTimeTrackerLocalStorage = (
    timeTrackerLocalStorage: ITimeTrackerLocalStorage
) => {
    localStorage.setItem(TIME_TRACKER_LOCALSTORAGE, JSON.stringify(timeTrackerLocalStorage))
};
